<template>
  <Modal
      v-model="_value"
      width="500"
      title="追加备注"
      @on-visible-change="visibleChange"
      ok-text="确认修改"
      @on-ok="onOk"
      cancel-text="关闭">
    <Form :model="attentionVehicleAnalysiss" style="display: inline;">
      <FormItem prop="result">
        <label style="display: inline-block; width: 60px;">备注</label>
        <Input style="display: inline-block; width: 400px;" type="textarea"
               v-model="attentionVehicleAnalysiss.processRemark" placeholder="备注">
        </Input>
      </FormItem>
      <FormItem prop="processState">
        <label style="display: inline-block; width: 100px;">观察时间</label>
        <DatePicker style="display: inline-block; width: 300px;" v-model="attentionVehicleAnalysiss.observationDatetime" type="date" placeholder="如需观察期请输入观察时间"></DatePicker>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'processattentionvehiclemodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      attentionVehicleAnalysiss: {
        id: null,
        processRemark: null,
        observationDatetime: null
      }
    }
  },
  methods: {
    ...mapActions([
      'AttentionVehicleAnalysisServ_ModifyRemark',
      'AttentionVehicleAnalysisServ_GetDetail'
    ]),
    onOk () {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认追加备注</p>',
        onOk: () => {
          if(this.attentionVehicleAnalysiss.observationDatetime){
            this.attentionVehicleAnalysiss.observationDatetime = this.attentionVehicleAnalysiss.observationDatetime.getTime()
          }else{
            this.attentionVehicleAnalysiss.observationDatetime = null
          }
          store.dispatch('AttentionVehicleAnalysisServ_AddProcessRemark', {
            params: this.attentionVehicleAnalysiss
          }).then(() => {
            this.$Message.success('追加成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {

        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.attentionVehicleAnalysiss.id = null
        this.attentionVehicleAnalysiss.processRemark = null
        this.attentionVehicleAnalysiss.observationDatetime = null
        let id = this._initValue
        if (id) {
          store.dispatch('AttentionVehicleAnalysisServ_GetDetail', {
            params: { id: this._initValue }
          }).then(() => {
            this.attentionVehicleAnalysiss = store.getters.get_AttentionVehicleAnalysis_GetDetailResult
            if(this.attentionVehicleAnalysiss.observationDatetime){
              this.attentionVehicleAnalysiss.observationDatetime = new Date(this.attentionVehicleAnalysiss.observationDatetime)
            }
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
